// The header wrapper leaves the document flow when it sticks (position: fixed), so any
// document-space coordinate (offsetTop) shifts by its height mid-interaction. Measuring in
// viewport space and moving by a delta keeps the result idempotent: repeated calls settle at
// the same on-screen position instead of flipping the header between resting and stuck.
export const getCollectionScrollDelta = (anchorTop, stickyOffset) => {
  const delta = anchorTop - stickyOffset;
  return delta < -1 ? delta : 0;
};

export const scrollCollectionIntoView = () => {
  const anchor = document.getElementById('collection-start');
  if (!anchor) return 0;
  const stickyOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--menu-height-sticky')) || 0;
  const delta = getCollectionScrollDelta(anchor.getBoundingClientRect().top, stickyOffset);
  if (!delta) return 0;
  window.scrollBy({ top: delta, behavior: 'smooth' });
  return delta;
};
